/* snap-enhance.js: Einrasten am Desktop, v26 (16.10.2026). Bericht: ~/Documents/Claude-ZinCuTec/Redesign/SCROLL-EINRASTEN.md
   Früher CSS-Einrasten (scroll-snap-type: y proximity) auf Start, ZEN, TUKKON und Über uns. Das zog langsames Scrollen mit Trackpad und
   Mausrad an jedem Punkt zurück (Messung: 60 Raddrehungen von oben = 0 px). Jetzt nur noch in Scrollrichtung:
   Hört man mit Rad oder Trackpad auf zu scrollen und steht ein Vollbild-Kapitel höchstens ein Viertel Bildschirm vor der Kopfleiste,
   gleitet die Seite dorthin weiter. Nie zurück (Ausnahme: ZEN-Bühne der Startseite, siehe BAND_GANZ), nie nach Tastatur, Ankern, Zurück-Knopf oder Ziehen der Scrollleiste, erst ab 1024 px
   (darunter zeigt v26 das Tablet-Layout), nicht bei „Bewegung reduzieren“, nicht bei offenem Menü oder Fenster. */
(function () {
  function guardExpandableMenuLink(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a.om-link-expandable');
    if (!link) return;
    event.preventDefault();
    link.removeAttribute('href');
  }

  document.addEventListener('click', guardExpandableMenuLink, true);

  if (!window.matchMedia) return;
  // Titelbilder: Ziel ist der Seitenanfang (nur beim Hochscrollen erreichbar). Bühnen: Oberkante unter die feste Kopfleiste.
  var TITEL = '.hero-video, .zenroom-hero, .about-hero, .zd-bs-hero, .zd-bh-hero';
  var BUEHNEN = '.zenroom:not(.zenroom-hero), .tukkon-lifestyle, .tukkon-vogue, .tukkon-character, .tukkon-brass, .zd-bs-story, .manifesto';
  var UNTER_LEISTE = 'body[data-page="home"] .zenroom:not(.zenroom-hero)';
  var OHNE = ['pdp', 'cart', 'search'];  // Kaufen und Suche bleiben ohne
  var BAND = 0.25;                       // höchstens ein Viertel der sichtbaren Höhe
  // ZEN-Bühne der Startseite rastet stärker ein: sie zieht schon aus 40 % heran, und wer in derselben Wischbewegung über ihre Kante
  // hinausrutscht (höchstens ein Viertel daneben), gleitet zurück. Eine neue Bewegung von der eingerasteten Bühne aus zieht nie zurück,
  // sonst säße man fest wie beim alten CSS-Einrasten.
  var BAND_GANZ = 0.4, RUECK_GANZ = 0.25;
  var desktop = window.matchMedia('(min-width: 1024px)'), ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var rad = 0, taste = 0, gedrueckt = false, letzteY = window.scrollY, richtung = 0, warten = 0;

  // Scrollstand zu Beginn der Wischbewegung (Rad oder Trackpad, Pause über 300 ms = neue Bewegung). Gemerkt wird der Ruhepunkt am Ende
  // der letzten Bewegung: beim ersten Rad-Ereignis hat der Browser die Seite oft schon verschoben.
  var start = null, ruheY = window.scrollY;
  var spaeter = 0;                       // Einrasten kurz nach dem Scrollende; scrollt man weiter, fällt es weg (kein Gegenschieben)
  window.addEventListener('wheel', function () { var t = performance.now(); clearTimeout(spaeter); if (start === null || t - rad > 300) start = ruheY; rad = t; }, { passive: true, capture: true });
  window.addEventListener('keydown', function () { taste = performance.now(); }, true);
  window.addEventListener('pointerdown', function () { gedrueckt = true; }, true);
  window.addEventListener('pointerup', function () { gedrueckt = false; }, true);
  window.addEventListener('pointercancel', function () { gedrueckt = false; }, true);
  window.addEventListener('scroll', function () {
    var y = window.scrollY; if (y !== letzteY) richtung = y > letzteY ? 1 : -1; letzteY = y;
    if (!('onscrollend' in window)) { clearTimeout(warten); warten = setTimeout(ende, 150); }
  }, { passive: true });
  if ('onscrollend' in window) window.addEventListener('scrollend', ende);

  // Ankerlinks (Sprunglink, „Inner Circle“ in der Ankündigung) landen unter der festen Kopfleiste statt dahinter: Höhe als --zd-leiste,
  // CSS setzt sie als scroll-margin-top nur auf das Anker-Ziel (:target, zct-v26.css). Nicht als scroll-padding auf der ganzen Seite:
  // Safari schob damit die Seite beim Schließen eines Ausklappers um die Leistenhöhe hoch (Fokus zurück auf den Knopf in der Leiste).
  function leiste() { var nav = document.querySelector('nav.nav'); if (nav) document.documentElement.style.setProperty('--zd-leiste', nav.offsetHeight + 'px'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', leiste); else leiste();
  if (desktop.addEventListener) desktop.addEventListener('change', leiste);

  function gesperrt() {
    var h = getComputedStyle(document.documentElement), b = getComputedStyle(document.body);
    return h.overflowY === 'hidden' || b.overflowY === 'hidden' || b.position === 'fixed';
  }
  function ende() {
    clearTimeout(spaeter);
    if (performance.now() - rad > 300) ruheY = window.scrollY;
    spaeter = setTimeout(function () { einrasten(); ruheY = window.scrollY; }, 140);
  }
  function einrasten() {
    var jetzt = performance.now();
    if (!desktop.matches || ruhig.matches || gedrueckt || !richtung) return;
    if (jetzt - rad > 550 || jetzt - taste < 800) return; // nur nach Rad oder Trackpad
    if (OHNE.indexOf(document.body.getAttribute('data-page')) >= 0 || gesperrt()) return;
    var nav = document.querySelector('nav.nav'), kopf = nav ? nav.offsetHeight : 65;
    var sicht = window.innerHeight - kopf, band = sicht * BAND, y = window.scrollY, ziel = null, abstand = Infinity;
    function pruefen(zielY, b) {
      var d = zielY - y; b = b || band;
      if (richtung > 0 ? (d > 2 && d <= b) : (d < -2 && d >= -b)) { if (Math.abs(d) < abstand) { abstand = Math.abs(d); ziel = zielY; } }
    }
    var zurueck = null;
    document.querySelectorAll(TITEL).forEach(function (e) { if (e.getBoundingClientRect().top + y < 300) pruefen(0); });
    document.querySelectorAll(BUEHNEN).forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.height < sicht * 0.9) return; // nur Abschnitte, die den Bildschirm füllen
      // Die ZEN-Bühne der Startseite rastet ganz oben ein: die Leiste ist dort durchsichtig (zct-kopf.js), das Bild füllt den Bildschirm
      var ganz = e.matches(UNTER_LEISTE) && document.body.hasAttribute('data-zd-klar');
      var t = Math.round(r.top + y - (ganz ? 0 : kopf));
      if (!ganz) { pruefen(t); return; }
      pruefen(t, sicht * BAND_GANZ);
      if (start !== null && (start - t) * (y - t) < 0 && Math.abs(y - t) > 2 && Math.abs(y - t) <= sicht * RUECK_GANZ) zurueck = t;
    });
    if (zurueck !== null) ziel = zurueck;
    if (ziel !== null) window.scrollTo({ top: ziel, behavior: 'smooth' });
  }
})();
